import { useEffect, useState } from 'react';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Autocomplete, CircularProgress, Box, Link, Checkbox, Typography, FormGroup, Tooltip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { addPartiesApi, getRoleListApi, updatePartiesApi } from '../apiService';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import { checkApiStatus } from '../../../../utils';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { setFileUploadDetails, setRole } from '../../../../shared_elements/actions';
import { trackActivity } from '../../../../utils/mixpanel';
import { formatBytes } from '../../../../utils/fileUpload';
import { useNavigate } from 'react-router-dom';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const PartiesCRU = ({ onToggleModal, uploadFileProgressData,partiesInfo,fileUpload, onOpenAttachments, modeType, params, addEditParties, getResponseBack }) => {
   
    const dispatch = useDispatch()
    const navigate=useNavigate();
    const { roleList,storageDetails } = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false);
    const [parties, setParties] = useState(addEditParties?.data);
    const [error, setError] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [cleared, setCleared] = useState(false);
    const [dropDownloader,setDropDownLoader]=useState(false)
   
    useEffect(() => {
        setDropDownLoader(true)
        globalGetService(getRoleListApi()).then((res) => {
            dispatch(setRole(res?.data?.data?.list))
            setDropDownLoader(false)
        })
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [])



    const findAttachmentsByLeaseId = (data, leaseId) => {
        const lease = data.list.find(item => item.id === leaseId);

        if (lease) {
            return {
                count: lease.attachments.length,
                attachments: lease.attachments
            };
        } else {
            return {
                count: 0,
                attachments: []
            };
        }
    }



    const onAddEditParties = () => {
        const validationInputs = {
            name: parties?.name?.trim() ? "" : "Please enter Name",
            role_id: parties?.role_id?.name ? "" : "Please select Role",
            start_date: parties?.start_date ? "" : "Please select Start Date",
            end_date: parties?.end_date ? "" : "Please select End Date",
        };
        const startDate = moment(parties?.start_date);
        const endDate = moment(parties?.end_date);
        if (parties?.start_date && parties?.end_date) {
            if (endDate.isBefore(startDate)) {
                validationInputs.end_date = "End date cannot be before start date";
            }
            if (startDate.isAfter(endDate)) {
                validationInputs.start_date = "Start date cannot be after end date";
            }
            if(parties?.start_date && !startDate.isValid()) {
                validationInputs.start_date = "Please enter valid Start date";
            }
            if(parties?.end_date && !endDate.isValid()) {
                validationInputs.end_date = "Please enter valid End Date";
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);

            if (parties.id) {
                globalPutService(
                    updatePartiesApi({ leaseSlug: params?.leaseSlug, slug: parties?.slug }),
                    parties
                ).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (uploadedFiles?.length > 0) {
                             fileUpload(parties.slug,'updated');
                        }
                        onToggleModal();
                        getResponseBack();
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, {
                            variant: "success",
                            anchorOrigin: { horizontal: "right", vertical: "top" },
                        });
                        trackActivity('Item Edited', { page_title: `Edit Party`, success_msg: response?.data?.message, item_id: parties?.id, payload: parties, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, {
                            variant: "error",
                            anchorOrigin: { horizontal: "right", vertical: "top" },
                        });
                        trackActivity('Item Edited', { page_title: `Edit Party`, error_msg: response?.data?.message, item_id: parties?.id, payload: parties, response: response?.data })
                    }
                });
            } else {
                globalPostService(
                    addPartiesApi({ leaseSlug: params?.leaseSlug }),
                    parties
                ).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (uploadedFiles?.length > 0) {
                             fileUpload(response?.data?.data.slug,'created');
                        }
                        onToggleModal();
                        getResponseBack();
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, {
                            variant: "success",
                            anchorOrigin: { horizontal: "right", vertical: "top" },
                        });
                        trackActivity('Item Added', { page_title: `Add Party`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: parties, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, {
                            variant: "error",
                            anchorOrigin: { horizontal: "right", vertical: "top" },
                        });
                        trackActivity('Item Added', { page_title: `Add Party`, error_msg: response?.data?.message, item_id: null, payload: parties, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Party`, error_msg: validationInputs, })
        }
    };



    const handleFileChange = (files) => {
        setUploadedFiles(files);
        dispatch(setFileUploadDetails({attachments:files}))
    };

    const onFieldChange = (keyParam, value) => {
        setParties({ ...parties, [keyParam]: value });

    }
    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }
   
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Party`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={addEditParties.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? 'Add Party' : modeType === 'edit' ? 'Edit Party' : 'View Party'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                required
                                id="name"
                                value={parties?.name || ''}
                                label="Name"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                error={!!error.name}
                                helperText={error.name}
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth
                                disabled={modeType === 'view'}
                                onFocus={() => onRestErrorKey("name")}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value.length <= 50 ? onFieldChange("name", e.target.value.trimStart()) : e.preventDefault() : ""}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disableClearable
                                disablePortal
                                options={roleList || []}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option.name || ""}
                                noOptionsText={dropDownloader ? "Loading..." : <Link onClick={() => navigate(`/settings/party-role`)} sx={{ textDecoration: "none", cursor: "pointer" }} >+ Add New Role</Link> }
                                onFocus={() => onRestErrorKey("role_id")}
                                value={parties?.role_id || null}
                                onChange={(e, value) => onFieldChange('role_id', value)}
                                onInputChange={(event, newInputValue) => {
                                    if (newInputValue.trim() !== "") {
                                        setError((prev) => ({ ...prev, role_id: "" }));
                                    }
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                required
                                                {...params}
                                                label="Role"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.role_id)}
                                                helperText={error.role_id}
                                                slotProps={{
                                                    inputLabel: { shrink: true, }, input: {
                                                        ...params?.InputProps, endAdornment: (<>
                                                            {modeType !== "view" && dropDownloader && (
                                                                <CircularProgress color="inherit" size={20} />
                                                            )}
                                                            {params.InputProps.endAdornment}
                                                        </>)
                                                    }
                                                }}
                                                disabled={modeType === 'view'}
                                            />
                                        </Tooltip>
                                    )
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="contact_address"
                                value={parties?.contact_address || ''}
                                label="Contact Address"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={modeType === 'view'}
                                onChange={(e) =>  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value.length <= 250 ? onFieldChange("contact_address", e.target.value.trimStart()) : e.preventDefault() : ""}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="jurisdiction"
                                value={parties?.jurisdiction}
                                label="Jurisdiction"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                error={!!error.jurisdiction}
                                helperText={error.jurisdiction}
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth
                                disabled={modeType === 'view'}
                                onFocus={() => onRestErrorKey("jurisdiction")}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value.length <= 50 ? onFieldChange("jurisdiction", e.target.value.trimStart()): e.preventDefault() : ""}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="concerned_person_name"
                                value={parties?.concerned_person_name || ''}
                                label="Concerned Person Name"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={modeType === 'view'}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value.length <= 50 ? onFieldChange("concerned_person_name", e.target.value.trimStart()): e.preventDefault() : ""}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="concerned_person_designation"
                                value={parties?.concerned_person_designation || ''}
                                label="Concerned Person Designation"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={modeType === 'view'}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value.length <= 50 ? onFieldChange("concerned_person_designation", e.target.value.trimStart()): e.preventDefault() : ""}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Start Date"
                                    value={parties?.start_date ? moment(parties.start_date) : null}
                                    onChange={(value) => {
                                        const isValid = moment(value)?.isValid();
                                        const formattedDate = isValid ? moment(value).format(backendDateFormat) : null;
                                        onFieldChange("start_date", value ? moment(value).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("start_date");
                                            if (parties?.end_date && !moment(formattedDate).isAfter(moment(parties.end_date))) {
                                                setError(prev => ({ ...prev, start_date: "", end_date: "" }));
                                            }
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            required: "true",
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.start_date || false,
                                            helperText: error.start_date || '',
                                            onFocus: () => { error.start_date && onRestErrorKey("start_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("start_date", null);
                                                onRestErrorKey("start_date");
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="End Date"
                                    value={parties?.end_date ? moment(parties.end_date) : null}
                                    onChange={(value) => {
                                        const isValid = moment(value)?.isValid();
                                        const formattedDate = isValid ? moment(value).format(backendDateFormat) : null;
                                        onFieldChange("end_date", value ? moment(value).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("end_date");
                                            if (parties?.start_date && !moment(formattedDate).isBefore(moment(parties.start_date))) {
                                                setError(prev => ({ ...prev, start_date: "", end_date: "" }));
                                            }
                                        }
                                    }}
                                    minDate={parties?.start_date ? moment(parties.start_date) : null}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.end_date || false,
                                            helperText: error.end_date || '',
                                            onFocus: () => { error?.end_date && onRestErrorKey("end_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("end_date", null);
                                                onRestErrorKey("end_date");
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                         <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="country"
                                value={parties?.country || ''}
                                label="Country"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={modeType === 'view'}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value.length <= 50 ? onFieldChange("country", e.target.value.trimStart()): e.preventDefault() : ""}
                            />
                        </Grid>
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Remarks' value={parties?.remarks || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id="remarks"
                                    value={parties?.remarks || ''}
                                    label="Remarks"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    fullWidth
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    multiline
                                    rows={3}
                                    onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, remarks: "" }));
                                }}
                                />
                            </Grid>}
                        <Grid size={{ xs: 12, md: 12 }} sx={{ marginRight: '5px' }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <Box className="check-item-div" sx={{ cursor: modeType === "view" ? "not-allowed" : "pointer" }}>
                                    <Checkbox sx={{ paddingLeft: 0 }} disableRipple checked={parties?.is_trustee ? true : false} onChange={(e) => onFieldChange("is_trustee", e.target.checked)} disabled={modeType === 'view'} />
                                    <Typography className="check-item-span" fontSize='14px'>Default Trustee</Typography>
                                </Box>
                            </FormGroup>
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                            {parties?.id && parties?.attachments?.length ?
                                <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({findAttachmentsByLeaseId(partiesInfo, parties?.id)?.count})Attachment(s)</Button> : null
                            }
                            <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                          </Box>
                            {addEditParties?.mode === 'view' ? null : <AttachementsUpload  onFileChange={handleFileChange} attachments={parties?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant='contained' className='btn-primary' size='small' disabled={modeType === "view"} onClick={() => { handleItemClicked('Save Button'); onAddEditParties() }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"} </Button>}
                </DialogActions>
            </Dialog>
        </>

    )
}
export default PartiesCRU;